import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Situações do Estudante — migração de `SAEWEBC/WEB/MenuAcademico/CadastrarSituacao.aspx`.
 *
 * CRUD da tabela `Situacao`. Permissão PRÓPRIA
 * (`SITUACOESDOESTUDANTENOVO_MENU_300901099`), vizinha da legada 300901003 — enquanto as duas
 * telas convivem, a rede precisa liberar uma sem a outra.
 */
export default [
  {
    description: 'Situações do Estudante',
    path: '/academico/parametros/situacoes',
    name: 'situacoes_estudante',
    component: () => import('@/views/academico/parametros/situacoes/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.SITUACOESDOESTUDANTENOVO_MENU_300901099],
    },
    goesToMenu: true,
  },
];
